/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mcp_Cap_Library_Example_NotesInputs */

const en_mcp_cap_library_example_notes = /** @type {(inputs: Mcp_Cap_Library_Example_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meeting notes`)
};

const es_mcp_cap_library_example_notes = /** @type {(inputs: Mcp_Cap_Library_Example_NotesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notas de la reunión`)
};

/**
* | output |
* | --- |
* | "Meeting notes" |
*
* @param {Mcp_Cap_Library_Example_NotesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mcp_cap_library_example_notes = /** @type {((inputs?: Mcp_Cap_Library_Example_NotesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mcp_Cap_Library_Example_NotesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mcp_cap_library_example_notes(inputs)
	return en_mcp_cap_library_example_notes(inputs)
});